module.exports = __webpack_public_path__ + "static/img/homepage2.ea4fe86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/homepage2.jpg
// module id = olU6
// module chunks = 1